import React, {useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useNavigate} from 'react-router-dom'
import {DELETE_USER} from "@/common/Constant"
import Confirm from "@/view/common/popup/Confirm"
import UserService from "@/service/UserService";
import StorageUtil from "@/common/StorageUtil";

const DeleteUser = () => {
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false)

    const {refetch: deleteUser} = useQuery<any, AxiosError>(
        ['deleteUser'],
        ()=> UserService.deleteUser(StorageUtil.getLocalStorage("USER_ID")?Number(StorageUtil.getLocalStorage("USER_ID")):0),
        {
            onSuccess: () => {
                StorageUtil.initStorage()
                navigate("/")
            }
        }
    )

    const logout = async () => {
        await deleteUser()
    }

    return (
        <>
            <div className='mrml-24px ptpb-22px border-top-gray text-center button2-style cl-point06 c1_r' onClick={() => setIsOpen(true)}>
                {DELETE_USER.BTN}
            </div>
            <Confirm content={<span>계정을 삭제 하시겠습니까?</span>} title={undefined} leftBtnContent={'삭제'} rightBtnContent={'취소'} isOpen={isOpen} onClick={() => logout()} onClose={ () => setIsOpen(false)}/>
        </>
    )
};

export default DeleteUser;